import { Badge, Dot, formatTime } from "@xola/ui-kit";
import React from "react";
import { TimeRange } from "types";
import { NoTranslate } from "./NoTranslate";

export const ScheduleTimeRanges = ({
    timeRanges,
    productStyling,
}: {
    timeRanges: TimeRange[];
    productStyling?: boolean;
}) => {
    return (
        <div className="flex flex-wrap items-center text-gray-darker" data-testid="base-schedule-summary-time-range">
            {/* Basically like `Array.join()` but for React components */}
            {timeRanges.flatMap((timeRange, index, array) => {
                const time = [formatTime(timeRange.startTime), formatTime(timeRange.endTime)].join(" - ");
                const isLast = array.length - 1 === index;
                const key1 = `${time}-${index}`;
                const key2 = `${time}-${index + 1}`;

                return (
                    <div className="mr-2 mb-2">
                        {isLast ? (
                            <Timerange key={key1} productStyling>
                                {time}
                            </Timerange>
                        ) : (
                            [
                                <Timerange key={key2} productStyling>
                                    {time}
                                </Timerange>,
                                productStyling ? null : <Dot key={`${time}-${index + 2}`} color="secondary" />,
                            ]
                        )}
                    </div>
                );
            })}
        </div>
    );
};

const Timerange = ({ children, productStyling, ...props }: { children: string; productStyling: boolean }) => {
    if (productStyling) {
        return (
            <Badge color="secondary">
                <NoTranslate>{children}</NoTranslate>
            </Badge>
        );
    }

    return (
        <span {...props}>
            <NoTranslate>{children}</NoTranslate>
        </span>
    );
};
